export default __webpack_public_path__ + "static/media/MapaUSActualizado03.4c8eab14.png";